var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGlo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0797 28.5673C23.1806 28.5673 28.937 22.8109 28.937 15.7101C28.937 8.60918 23.1806 2.85278 16.0797 2.85278C8.97881 2.85278 3.22241 8.60918 3.22241 15.7101C3.22241 22.8109 8.97881 28.5673 16.0797 28.5673Z",
    fill: "#50B651"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.663,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.8976 15.6738C28.8976 22.797 23.1232 28.5714 16.0016 28.5714C8.88 28.5714 3.104 22.797 3.104 15.6738C3.104 12.5228 3.19232 12.0543 4.43264 10.2604C4.43264 10.2604 4.36864 12.2866 5.8544 13.4924C6.77824 14.2415 7.7424 13.7007 9.5072 12.8879C11.4163 12.0079 12.9683 11.4402 14.1792 11.59C16.0032 11.8159 21.6253 15.1922 24.5594 14.5199C26.9034 13.9839 26.656 8.45752 26.656 8.45752C29.216 10.9574 28.8976 12.647 28.8976 15.6738Z",
    fill: "url(#paint0_linear_3142_60630)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.586,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5359 25.1474C26.2004 20.7598 26.9758 15.7332 23.862 10.0677C23.8778 10.0792 24.0704 9.4145 24.4399 8.07349C26.0971 10.0803 26.9782 12.5573 27.0834 15.5045C27.0826 19.3219 25.2334 22.5362 21.5359 25.1474Z",
    fill: "url(#paint1_linear_3142_60630)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.744,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3236 8.10027C17.0721 6.85419 14.4891 4.34763 14.8324 3.82123C15.1758 3.29483 19.6324 3.38539 21.8843 4.63147C24.1361 5.87755 26.0526 9.61547 25.7095 10.1419C25.3665 10.6683 21.5751 9.34635 19.3236 8.10027Z",
    fill: "url(#paint2_radial_3142_60630)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2849 18.8764C19.4171 18.8764 17.9028 17.319 17.9028 15.398C17.9028 13.477 19.4171 11.9199 21.2849 11.9199C23.1528 11.9199 24.6673 13.477 24.6673 15.398C24.6673 17.319 23.1531 18.8764 21.2849 18.8764ZM21.3089 17.773C22.4747 17.773 23.4209 16.7097 23.4209 15.398C23.4209 14.0863 22.4747 13.0239 21.3089 13.0239C20.1432 13.0239 19.1969 14.0873 19.1969 15.3986C19.1969 16.71 20.1432 17.773 21.3089 17.773Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3066 9.11938H16.7438V18.8378H15.4058V10.1853H14.3066V9.11938Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4903 12.0188H13.7552V20.1346C13.7552 20.8741 12.9773 21.6444 12.2192 21.9759C11.8608 22.1325 11.1995 22.2255 10.2352 22.2549V21.4476C11.1784 21.3424 11.8149 21.1326 12.145 20.8181C12.3354 20.5535 12.4544 20.2442 12.4906 19.9202V17.5359C12.1524 18.2533 11.7266 18.729 11.2131 18.9628C10.6794 19.2508 9.59297 19.2034 9.14945 18.9628C8.70593 18.7221 8.05537 18.0885 7.75713 17.1449C7.67457 16.8844 7.46913 16.1756 7.49057 15.4245C7.50977 14.7093 7.74657 13.9525 7.94337 13.6415C8.28129 13.1103 8.81409 12.445 9.62113 12.1669C10.0154 12.031 10.746 11.9822 11.8131 12.0204V12.8233C11.0202 12.7697 10.5255 12.7965 10.329 12.9036C10.0343 13.0636 9.36897 13.261 9.14945 14.7109C8.92993 16.1609 9.15585 17.3474 9.85185 17.7189C10.0903 17.8469 10.512 17.9983 10.9018 17.8649C11.6506 17.6089 12.3552 16.6959 12.409 16.0773C12.4632 15.4497 12.4903 14.0969 12.4903 12.0188Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4934 18.2555C27.2988 24.0075 22.2018 28.3294 16.0959 28.3294C9.10296 28.3294 3.43384 22.6603 3.43384 15.6673C3.43384 11.323 5.62168 7.48972 8.95544 5.20972C6.24664 7.45612 4.52184 10.8497 4.52184 14.6446C4.52184 21.4136 10.0092 26.9006 16.7778 26.9006C22.2902 26.9006 26.9519 23.2619 28.4934 18.2555Z",
    fill: "url(#paint3_radial_3142_60630)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0961 0.672119C7.81451 0.672119 1.10059 7.38572 1.10059 15.6673C1.10059 23.9489 7.81451 30.6628 16.0961 30.6628C24.3777 30.6628 31.0916 23.9489 31.0916 15.6673C31.0916 7.38572 24.3777 0.672119 16.0961 0.672119ZM16.0961 28.3297C9.10314 28.3297 3.43403 22.6606 3.43403 15.6676C3.43403 11.3233 5.62187 7.49004 8.95563 5.21004C11.0581 3.77006 13.5478 3.00132 16.0961 3.00524C23.0891 3.00524 28.7582 8.67404 28.7582 15.6673C28.7586 16.5368 28.67 17.4041 28.4935 18.2555C27.299 24.0075 22.202 28.3294 16.0961 28.3294V28.3297Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3142_60630",
    x1: 15.5034,
    y1: 10.2188,
    x2: 17.1565,
    y2: 25.1478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#123214"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#3E7C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#5FBB46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3142_60630",
    x1: 25.0535,
    y1: 9.2483,
    x2: 25.0535,
    y2: 21.3204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "white",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.42
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_3142_60630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.545 7.06613) rotate(26.7606) scale(6.35338 2.64607)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "white",
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "white",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_3142_60630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.2672 12.7499) rotate(39.84) scale(14.2378 15.5192)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlo);
export default __webpack_public_path__ + "static/media/glo.7ea1ce9ef7455c6f1a1538478895d4ff.svg";
export { ForwardRef as ReactComponent };